import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorios`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioGeralSaidaPaciente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-geral-saida-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
